var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/users/manager") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0001 46 0.0001 46 20 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 57.9659 46 57.9659 46 -0.0001 0 -0.0001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/users/manager",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(17.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 37.965900)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,6.3481 C39.086,1.7041 31.261,0.0001 22.963,0.0001 C14.694,0.0001 6.896,1.6851 0,6.2981 L0,20.0001 L46,20.0001 L46,6.3481 Z",
    id: "Fill-1",
    fill: "#99568F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.7744,57.9659 L26.2254,57.9659 L32.4034,38.8169 C29.3444,38.2279 26.1904,37.9659 22.9624,37.9659 C19.7594,37.9659 16.6284,38.2229 13.5914,38.8009 L19.7744,57.9659 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,26.9659 L9,13.9659 C9,6.2079 15.194,-0.0001 22.953,-0.0001 C30.711,-0.0001 37,6.2889 37,14.0479 L37,26.9659 C37,34.6979 30.732,40.9659 23,40.9659 C15.268,40.9659 9,34.6979 9,26.9659",
    id: "Fill-6",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,38.315 L29,28.966 L17,28.966 L17,38.305 C15.853,38.433 14.714,38.587 13.592,38.801 L16.321,47.263 C18.477,47.72 20.709,47.966 23,47.966 C25.291,47.966 27.523,47.72 29.679,47.263 L32.403,38.816 C31.283,38.601 30.146,38.444 29,38.315",
    id: "Fill-8",
    fill: "#F0C6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,29.0284 L29,34.2154 C25.625,37.2164 21.125,37.6444 17,37.3054 L17,29.9654 L29,29.0284 Z",
    id: "Fill-10",
    fill: "#C29F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,22.9757 C33,28.5077 28.516,32.9927 22.982,32.9927 C17.45,32.9927 13.004,28.5077 13.004,22.9757 L13.004,16.0547 C13.004,10.5217 17.45,6.0377 22.982,6.0377 C28.516,6.0377 33,10.5217 33,16.0547 L33,22.9757 Z",
    id: "Fill-12",
    fill: "#F0C6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,8.6534 L26.563,6.5904 L13,15.0904 L13,19.9664 C20.417,18.7994 24.042,14.4244 26,10.9664 C28.333,13.0074 32.938,14.3034 32.938,16.6534 L33,8.6534 Z",
    id: "Fill-14",
    fill: "#C29F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,17.2784 L34,10.3414 C32.3,6.5374 27.046,2.9434 22.978,2.9434 C16.337,2.9434 12,8.9654 13,16.9664 C13,16.9664 22.375,14.0904 27,7.9654 C28.875,10.2784 33,13.2784 33,17.2784",
    id: "Fill-16",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,16.9659 L35,16.9659",
    id: "Fill-18",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375,26.9659 C25.646,28.1529 24.358,28.9659 23,28.9659 C21.642,28.9659 20.396,28.1739 19.625,26.9659 L26.375,26.9659 Z",
    id: "Fill-20",
    fill: "#962851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,50.9659 L35,53.9659 L38,53.9659 L38,50.9659 C38,50.1369 37.328,49.4659 36.5,49.4659 C35.672,49.4659 35,50.1369 35,50.9659 Z",
    id: "Fill-22",
    fillOpacity: 0.2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,49.9659 L36,52.9659 L39,52.9659 L39,49.9659 C39,49.1369 38.328,48.4659 37.5,48.4659 C36.672,48.4659 36,49.1369 36,49.9659 Z",
    id: "Fill-24",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#B569AA",
    mask: "url(#mask-4)",
    points: "31 57.9659 40 57.9659 40 52.9659 31 52.9659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,16.9659 C19,17.5179 18.553,17.9659 18,17.9659 C17.447,17.9659 17,17.5179 17,16.9659 C17,16.4139 17.447,15.9659 18,15.9659 C18.553,15.9659 19,16.4139 19,16.9659",
    id: "Fill-28",
    fill: "#000000",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,16.9659 C29,17.5179 28.553,17.9659 28,17.9659 C27.447,17.9659 27,17.5179 27,16.9659 C27,16.4139 27.447,15.9659 28,15.9659 C28.553,15.9659 29,16.4139 29,16.9659",
    id: "Fill-29",
    fill: "#000000",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,16.4659 C21.5,18.9969 19.933,20.5279 18,20.5279 C16.067,20.5279 14.5,18.9349 14.5,16.4659 C16.375,15.1539 19.333,15.0699 21.5,16.4659 Z",
    id: "Stroke-30",
    stroke: "#000000",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,16.4659 C24.5,18.9969 26.067,20.5279 28,20.5279 C29.933,20.5279 31.5,18.9349 31.5,16.4659 C29.625,15.1539 26.667,15.0699 24.5,16.4659 Z",
    id: "Stroke-31",
    stroke: "#000000",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,16.4659 L24.458,16.4659",
    id: "Stroke-32",
    stroke: "#000000",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.583,16.4659 L34,16.4659",
    id: "Stroke-33",
    stroke: "#000000",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16.4659 L14.542,16.4659",
    id: "Stroke-34",
    stroke: "#000000",
    mask: "url(#mask-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManager);
export default __webpack_public_path__ + "static/media/manager.8137cf89fc1f3a9f0e978ebf927d496c.svg";
export { ForwardRef as ReactComponent };